// Used to select a specific measurement date based on the available FMDs and CMDs
const getMeasurementDate = ({ commonMeasurementDate, fallbackValue, measurementDates }) =>
  measurementDates
    ? measurementDates.find(measurementDate => measurementDate.date === commonMeasurementDate)?.id
    : fallbackValue;

export default getMeasurementDate;
